import React, { useState, useEffect, useContext, useRef } from 'react';
import {AnimatePresence, motion} from 'framer-motion';
// import { useUserAPI } from '../../components/useUserAPI';
import { ShoppingStart } from '../../components/ShoppingStart';

import styles from '../../styles/GetAttention.module.scss';

// import useSound from 'use-sound';
// import se_08 from '../../sound/s08_se_delay0.mp3';
// import se_10 from '../../sound/s10_item_delete.mp3';
import Lottie from 'react-lottie';
import animGetKuji from '../../images/get_kuji';
import animGetBonus from '../../images/get_bonus';

const motionConfig01 = {
	initial: {
		y: -30,
		opacity: 0,
	},
	animate: {
		y: 0,
		opacity: 1,
	},
	hidden: {
		y: 30,
		opacity: 0,
	},
};
const motionConfig02 = {
	initial: {
		y: -20,
		opacity: 0,
	},
	animate: {
		y: 0,
		opacity: 1,
	},
	hidden: {
		y: 20,
		opacity: 0,
	},
};
const modalBox_cover = {
	initial: {
		opacity: 0,
	},
	animate: {
		opacity: 0.55,
	},
	hidden: {
		opacity: 0,
	},
};

export const GetAttention = (props) => {

// const [se08_se] = useSound(se_08);
// const [se10_delete,se10_delete_controls] = useSound(se_10);

// useEffect(() => {
// 	if(props.soundState !== "se10_delete" && props.soundState !== ""){
// 		se10_delete_controls.stop();
// 	}
// }, [props.soundState]);

// console.log(props.errNum);
// const [delItemFlg, setDelItemFlg] = useState(false)

// const delItem = (e) => {
// 	// e.stopPropagation();
// 	// props.setDelModal(false);

// 	document.querySelectorAll('.modalCloseBtn').forEach(function(element) {
// 		element.classList.add('is_nouse');
// 	});

// 	const bcode = props.delModal[0];
// 	const bnum = props.delModal[1];
// 	cancelAPI(ShoppingStartContext.data.token,bcode,bnum);

// 	se08_se();
// 	// setDelItemFlg(false);
// 	// props.setDelModal([]);
// 	// setDelItemFlg(true);
// 	// setTimeout(function(){
// 	// 	setDelItemFlg(false);
// 	// 	props.setDelModal([]);
// 	// }, 1200);
// }

// const closeModal = (e) => {
// 	e.stopPropagation();
// 	props.setDelModal([]);
// 	se08_se();
// }

// const { cancelAPI, data: cancelData, loading: cancelLoading, error: cancelError } = useUserAPI();
const ShoppingStartContext = useContext(ShoppingStart);

useEffect(() => {
	if(props.getAtState.length !== 0){
		console.log("props.getAtState: [" + props.getAtState + "]");
		if(props.getAtState[0] === false && props.getAtState[1] === true){ //ボーナス有効、くじ無効
			if (lottieGetBonusRef.current){
				lottieGetBonusRef.current.stop();
			}
			setTimeout(function(){
				document.getElementById('kuji_g2').classList.add(styles.is_active);
				document.getElementById('kuji_g2_bg').classList.add(styles.is_active);
				// get02.play();
				if (lottieGetBonusRef.current) {
					lottieGetBonusRef.current.play();
				}
				//お買物API：画面遷移API（ポップアップ表示
				props.okaimonoAPI_didScreenTransition("popup");
			}, 500);

		}else if(props.getAtState[0] === true && props.getAtState[1] === false){ //ボーナス無効、くじ有効
			if (lottieGetKujiRef.current) {
				lottieGetKujiRef.current.stop();
			}
			setTimeout(function(){
				document.getElementById('kuji_g1').classList.add(styles.is_active);
				document.getElementById('kuji_g1_bg').classList.add(styles.is_active);
				// get01.play();
				if (lottieGetKujiRef.current) {
					lottieGetKujiRef.current.play();
				}
				//お買物API：画面遷移API（ポップアップ表示
				props.okaimonoAPI_didScreenTransition("popup");
			}, 500);

		}else if(props.getAtState[0] === true && props.getAtState[1] === true){ //ボーナス有効、くじ有効
			if (lottieGetKujiRef.current) {
				lottieGetKujiRef.current.stop();
			}
			setTimeout(function(){
				document.getElementById('kuji_g1').classList.add(styles.is_active);
				document.getElementById('kuji_g1_bg').classList.add(styles.is_active);
				// get01.play();
				if (lottieGetKujiRef.current) {
					lottieGetKujiRef.current.play();
				}
				//お買物API：画面遷移API（ポップアップ表示
				props.okaimonoAPI_didScreenTransition("popup");
			}, 500);
		}
	}
}, [props.getAtState]);

const onCloseGet = (nextflg,sse) => {
	if(props.getAtState[0] === false && props.getAtState[1] === true){ //ボーナス有効、くじ無効
		// document.getElementById('kuji_g1').classList.remove(styles.is_active);
		document.getElementById('kuji_g2').classList.remove(styles.is_active);
		// document.getElementById('kuji_g1_bg').classList.remove(styles.is_active);
		document.getElementById('kuji_g2_bg').classList.remove(styles.is_active);
		setTimeout(function(){
			//お買物API：画面遷移API（ホーム画面
			props.okaimonoAPI_didScreenTransition("home");

			props.setGetAtState([]);
		}, 400);

	}else if(props.getAtState[0] === true && props.getAtState[1] === false){ //ボーナス無効、くじ有効
		document.getElementById('kuji_g1').classList.remove(styles.is_active);
		// document.getElementById('kuji_g2').classList.remove(styles.is_active);
		document.getElementById('kuji_g1_bg').classList.remove(styles.is_active);
		// document.getElementById('kuji_g2_bg').classList.remove(styles.is_active);
		setTimeout(function(){
			//お買物API：画面遷移API（ホーム画面
			props.okaimonoAPI_didScreenTransition("home");

			props.setGetAtState([]);
		}, 400);

	}else if(props.getAtState[0] === true && props.getAtState[1] === true){ //ボーナス有効、くじ有効
		if(nextflg === true){
			if (lottieGetBonusRef.current){
				lottieGetBonusRef.current.stop();
			}
			document.getElementById('kuji_g1').classList.remove(styles.is_active);
			document.getElementById('kuji_g1_bg').classList.remove(styles.is_active);
			setTimeout(function(){
				document.getElementById('kuji_g2').classList.add(styles.is_active);
				document.getElementById('kuji_g2_bg').classList.add(styles.is_active);
				// get02.play();
				console.log("lottieGetBonusRef.current.play()");
				if (lottieGetBonusRef.current) {
					lottieGetBonusRef.current.play();
				}
			}, 600);
		}else{
			document.getElementById('kuji_g1').classList.remove(styles.is_active);
			document.getElementById('kuji_g2').classList.remove(styles.is_active);
			document.getElementById('kuji_g1_bg').classList.remove(styles.is_active);
			document.getElementById('kuji_g2_bg').classList.remove(styles.is_active);
			setTimeout(function(){
				//お買物API：画面遷移API（ホーム画面
				props.okaimonoAPI_didScreenTransition("home");

				props.setGetAtState([]);
			}, 400);
		}
	}
	if(sse === true){
		props.setSoundState("se08_se");
	}
}

const lottieGetKujiRef = useRef(null);
const lottieGetBonusRef = useRef(null);

const getKujiOptions = {
    renderer: 'svg',
    loop: false,
    autoplay: false,
	animationData: animGetKuji
};
const getBonusOptions = {
    renderer: 'svg',
    loop: false,
    autoplay: false,
	animationData: animGetBonus
};


return (
	<AnimatePresence>
	{props.getAtState.length !== 0 && (
	<>
	{
		(() => {
		if(props.getAtState[0] === false && props.getAtState[1] === true){ //ボーナス有効、くじ無効
			return(
			<section id="getAttention" className="modalBox getAttentionModal">
				<div className="modalBox_wrap">
					<div className="modalBox_in">
						{/* <div id="kuji_g1" className={styles.getAttention}>
							<button className={styles.getAttention_closeBtn} onClick={()=>onCloseGet(true,true)}>
								<span>
									<img src="/images/icn_close01.svg" alt="" width="16" height="16" />
								</span>
							</button>
							<div id="kuji_get" className={`${styles.getAttention_wrap} ${styles.getAttention_wrap_kuji}`} onClick={()=>onCloseGet(true,true)}>
								<Lottie
									options={getKujiOptions}
									width={312}
									height={312}
									ref={lottieGetKujiRef}
								>
								</Lottie>
							</div>
						</div>
						<div id="kuji_g1_bg" className={`${styles.kuji_get_bg} ${styles.kuji_g1_bg}`} onClick={()=>onCloseGet(true,false)}></div> */}

						<div id="kuji_g2" className={styles.getAttention}>
							<div className={styles.getAttention_closeBtn} onClick={()=>onCloseGet(false,true)}>
								<span>
									<img src="/images/icn_close01.svg" alt="" width="16" height="16" />
								</span>
							</div>
							<div id="bonus_get" className={`${styles.getAttention_wrap} ${styles.getAttention_wrap_bonus}`} onClick={()=>onCloseGet(false,true)}>
								<Lottie
									options={getBonusOptions}
									width={312}
									height={312}
									ref={lottieGetBonusRef}
								>
								</Lottie>
							</div>
						</div>
						<div id="kuji_g2_bg" className={`${styles.kuji_get_bg} ${styles.kuji_g2_bg}`} onClick={()=>onCloseGet(false,false)}></div>
					</div>
					<motion.div className="modalBox_cover"
						initial={'initial'}
						animate={'animate'}
						exit={'hidden'}
						variants={modalBox_cover}
						transition={{duration: 0.35, ease: 'linear'}}
					></motion.div>
				</div>
			</section>
			)
		}else if(props.getAtState[0] === true && props.getAtState[1] === false){ //ボーナス無効、くじ有効
			return(
			<section id="getAttention" className="modalBox getAttentionModal">
				<div className="modalBox_wrap">
					<div className="modalBox_in">
						<div id="kuji_g1" className={styles.getAttention}>
							<div className={styles.getAttention_closeBtn} onClick={()=>onCloseGet(false,true)}>
								<span>
									<img src="/images/icn_close01.svg" alt="" width="16" height="16" />
								</span>
							</div>
							<div id="kuji_get" className={`${styles.getAttention_wrap} ${styles.getAttention_wrap_kuji}`} onClick={()=>onCloseGet(false,true)}>
								<Lottie
									options={getKujiOptions}
									width={312}
									height={312}
									ref={lottieGetKujiRef}
								>
								</Lottie>
							</div>
						</div>
						<div id="kuji_g1_bg" className={`${styles.kuji_get_bg} ${styles.kuji_g1_bg}`} onClick={()=>onCloseGet(false,false)}></div>

						{/* <div id="kuji_g2" className={styles.getAttention}>
							<button className={styles.getAttention_closeBtn} onClick={()=>onCloseGet(false,true)}>
								<span>
									<img src="/images/icn_close01.svg" alt="" width="16" height="16" />
								</span>
							</button>
							<div id="bonus_get" className={`${styles.getAttention_wrap} ${styles.getAttention_wrap_bonus}`} onClick={()=>onCloseGet(false,true)}>
								<Lottie
									options={getBonusOptions}
									width={312}
									height={312}
									ref={lottieGetBonusRef}
								>
								</Lottie>
							</div>
						</div>
						<div id="kuji_g2_bg" className={`${styles.kuji_get_bg} ${styles.kuji_g2_bg}`} onClick={()=>onCloseGet(false,false)}></div> */}
					</div>
					<motion.div className="modalBox_cover"
						initial={'initial'}
						animate={'animate'}
						exit={'hidden'}
						variants={modalBox_cover}
						transition={{duration: 0.35, ease: 'linear'}}
					></motion.div>
				</div>
			</section>
			)
		}else if(props.getAtState[0] === true && props.getAtState[1] === true){ //ボーナス有効、くじ有効
			return(
			<section id="getAttention" className="modalBox getAttentionModal">
				<div className="modalBox_wrap">
					<div className="modalBox_in">
						<div id="kuji_g1" className={styles.getAttention}>
							<div className={styles.getAttention_closeBtn} onClick={()=>onCloseGet(true,true)}>
								<span>
									<img src="/images/icn_close01.svg" alt="" width="16" height="16" />
								</span>
							</div>
							<div id="kuji_get" className={`${styles.getAttention_wrap} ${styles.getAttention_wrap_kuji}`} onClick={()=>onCloseGet(true,true)}>
								<Lottie
									options={getKujiOptions}
									width={312}
									height={312}
									ref={lottieGetKujiRef}
								>
								</Lottie>
							</div>
						</div>
						<div id="kuji_g1_bg" className={`${styles.kuji_get_bg} ${styles.kuji_g1_bg}`} onClick={()=>onCloseGet(true,false)}></div>

						<div id="kuji_g2" className={styles.getAttention}>
							<div className={styles.getAttention_closeBtn} onClick={()=>onCloseGet(false,true)}>
								<span>
									<img src="/images/icn_close01.svg" alt="" width="16" height="16" />
								</span>
							</div>
							<div id="bonus_get" className={`${styles.getAttention_wrap} ${styles.getAttention_wrap_bonus}`} onClick={()=>onCloseGet(false,true)}>
								<Lottie
									options={getBonusOptions}
									width={312}
									height={312}
									ref={lottieGetBonusRef}
								>
								</Lottie>
							</div>
						</div>
						<div id="kuji_g2_bg" className={`${styles.kuji_get_bg} ${styles.kuji_g2_bg}`} onClick={()=>onCloseGet(false,false)}></div>
					</div>
					<motion.div className="modalBox_cover"
						initial={'initial'}
						animate={'animate'}
						exit={'hidden'}
						variants={modalBox_cover}
						transition={{duration: 0.35, ease: 'linear'}}
					></motion.div>
				</div>
			</section>
			)
		}
		})()
	}

	</>
	)}
	</AnimatePresence>
)

}
